import React from 'react'
import { useForm } from '@inertiajs/react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface CreateDonationNatureSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

interface DonationNatureFormData {
  donation_nature: {
    name: string
  }
}

function defaultFormData(): DonationNatureFormData {
  return {
    donation_nature: {
      name: '',
    },
  }
}

export function CreateDonationNatureSheet({
  open,
  onOpenChange,
}: CreateDonationNatureSheetProps) {
  const form = useForm<DonationNatureFormData>(defaultFormData())

  function handleClose() {
    form.reset()
    onOpenChange(false)
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/fundraising/donation_natures', {
      onSuccess: () => {
        form.reset()
        onOpenChange(false)
      },
    })
  }

  return (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent className="w-[420px] sm:max-w-[420px] overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Nouvelle nature de don</SheetTitle>
          <SheetDescription>
            Ajoutez une nouvelle nature de don au systeme.
          </SheetDescription>
        </SheetHeader>

        <form onSubmit={handleSubmit} className="space-y-4 p-4">
          {/* Name */}
          <div className="space-y-2">
            <Label htmlFor="dn_name">Nom *</Label>
            <Input
              id="dn_name"
              value={form.data.donation_nature.name}
              onChange={(e) =>
                form.setData('donation_nature', {
                  ...form.data.donation_nature,
                  name: e.target.value,
                })
              }
              placeholder="Ex: Zakat"
              required
            />
            {/* The interaction returns flat attribute keys (`name`, `code`) via
                `outcome.errors.to_hash`; `code` carries the uniqueness error when
                a duplicate name collides on the generated slug. */}
            {(form.errors['name'] || form.errors['code']) && (
              <p className="text-sm text-destructive">
                {form.errors['name'] || form.errors['code']}
              </p>
            )}
          </div>

          <div className="flex gap-3 pt-2">
            <Button type="submit" disabled={form.processing} className="flex-1">
              {form.processing ? 'Creation...' : 'Creer'}
            </Button>
            <Button type="button" variant="outline" onClick={handleClose}>
              Annuler
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  )
}
